let resetForm = document.getElementById("reset-form");
let ajaxUrl = glide_custom_data.ajax_url;
let resetNonce = glide_custom_data.ajax_nonce;

if( resetForm ) {

    resetForm.addEventListener("submit", function (event) {
        event.preventDefault();
        
        $('#reset-modal-trigger').click();

        let password = document.getElementById('password').value.trim();
        let cPassword = document.getElementById('confirm-password').value.trim();
        let email = document.getElementById('email').value.trim();
        let reset = document.getElementById('reset').value.trim();
        let passwordValid = false;
        let cPasswordValid = false;

        if( reset == 'fail' ) {
            glide_ajax_loader_hide();
            $('.message-text').html('<p>Link expired. <br> Please request a new one</p>');
            return;
        }
        
        if( password == '' ) {
            passwordValid = false;
            glide_ajax_loader_hide();
            $('.message-text').html('<p>Enter new password</p>');
        } else {
            if( validatePassword(password) ) {
                passwordValid = true;
            } else {
                passwordValid = false;
                glide_ajax_loader_hide();
                $('.message-text').html('<p>Passwords must be <br> at least 10 characters and contain <br> an uppercase letter, <br> a lowercase letter, <br> a number and a symbol <br>  (like #, $, or %)</p>');
            }
        }
        
        if( passwordValid ) {
            if( cPassword == '' ) {
                cPasswordValid = false;
                glide_ajax_loader_hide();
                $('.message-text').html('<p>Re-type Password</p>');
            } else {
                if( password === cPassword ) {
                    cPasswordValid = true;
                } else {
                    cPasswordValid = false;
                    glide_ajax_loader_hide();
                    $('.message-text').html('<p>The passwords entered <br> do not match. <br> Please try again.</p>');
                }
            }
        }

        if( cPasswordValid ) {
            let urlParams = new URLSearchParams(window.location.search);
            let key = urlParams.get('key');

            var formData = {
                action: "user_reset_password",
                key: key,
                email: email,
                password: password,
                resetNonce: resetNonce,
            };

            glide_ajax_loader_show();

            jQuery.ajax({
                url: ajaxUrl,
                type: "POST",
                data: formData,
                success: function (response) {
                    glide_ajax_loader_hide();
                    if( response.success ) {
                        $('.message-text').html('<p>Thank you. <br> Your password <br> has been updated <br> successfully.</p>');
                        setTimeout(function() {
                            window.location.href = logged.message;
                        }, 1500);
                    } else {
                        if( response.data.message == 'email' ) {
                            $('.message-text').html('<p>Our system is facing <br> technical issues. <br> Please try again <br> in a few minutes</p>');
                        }
                        if( response.data.message == 'attack' ) {
                            $('.message-text').html('<p>Our system is facing <br> technical issues. <br> Please try again <br> in a few minutes</p>');
                        }
                        if( response.data.message == 'key' ) {
                            $('.message-text').html('<p>The password reset link seems to be invalid. <br> Please try again <br> in a few minutes</p>');
                        }
                    }
                },
                error: function () {
                    glide_ajax_loader_hide();
                    $('.message-text').html('<p>Our system is facing <br> technical issues. <br> Please try again <br> in a few minutes</p>');
                },
            });
        }

    });
}